import {PermAction, RequireFeature} from '@services/helper/permission.helper'
import {ComponentType, createElement, lazy} from 'react'

/**
 * Wrap a lazily-loaded page in a RequireFeature guard so a direct URL visit is
 * redirected to the landing page when the user lacks the feature. Kept JSX-free so
 * route files stay `.ts`. `anyOf` = feature URL(s) that grant access. `action` is what the
 * page needs on one of them: Show by default, 'create' for an add route, 'update' for an edit route.
 */
export const guard = (
  importer: () => Promise<{default: ComponentType<any>}>,
  anyOf: string[],
  action: PermAction = 'show'
) => {
  const Comp = lazy(importer)
  return () => createElement(RequireFeature, {anyOf, action, children: createElement(Comp)})
}
